import { IExportParams, IRequestParams } from './types';
import RecruitApiClient from '../../RecruitApiClient';
import { IEntity } from '../SmartForms/types';

const BASE_URL = '/api/v4';

class Api {
  getJobs = (params: IRequestParams) => RecruitApiClient.get(`${BASE_URL}/jobs`, params);
  getJob = (jobId: number) => RecruitApiClient.get(`${BASE_URL}/jobs/${jobId}`);
  getFilters = (url: string, params: { 'filter[archived]': boolean }) =>
    RecruitApiClient.get(`${BASE_URL}/jobs/${url}`, params);
  getJobFilterOptionsPaginated = (
    url: string,
    params: { 'filter[archived]': boolean; page: number }
  ) => RecruitApiClient.get(`${BASE_URL}/jobs/${url}`, params);
  getUISettings = (params) =>
    RecruitApiClient.get(`${BASE_URL}/ui_preferences`, params, {
      cache: 'no-cache'
    });
  postJobNote = (jobId: number, params: { job_note: { body: string } }) =>
    RecruitApiClient.post(`${BASE_URL}/jobs/${jobId}/job_notes`, params);
  postUISettings = (params: {}) => RecruitApiClient.post(`${BASE_URL}/ui_preferences`, params);
  putChangedState = (link: string) => RecruitApiClient.put(link);
  putChangedStatus = (jobId: number, statusID: number) =>
    RecruitApiClient.put(`${BASE_URL}/jobs/${jobId}/status/${statusID}`);
  putPinJob = (jobId: number) => RecruitApiClient.put(`${BASE_URL}/jobs/${jobId}/pin`);
  putUnpinJob = (jobId: number) => RecruitApiClient.put(`${BASE_URL}/jobs/${jobId}/unpin`);
  putArchiveJobs = (params: {}) => RecruitApiClient.put(`${BASE_URL}/jobs/archive`, params);
  putUnrchiveJobs = (params: {}) => RecruitApiClient.put(`${BASE_URL}/jobs/unarchive`, params);
  getCSVExport = (params: IExportParams) => RecruitApiClient.get(`${BASE_URL}/jobs/export`, params);
  referenceValidation = (params: {
    'job[reference]': string;
  }): Promise<{ res: { valid: boolean; correct_format: boolean } }> =>
    RecruitApiClient.get(`${BASE_URL}/jobs/validating_reference`, params);
  referencePrefix = (params) =>
    RecruitApiClient.get(`${BASE_URL}/jobs/auto_job_reference_setting`, params);
  importResources = (jobId: number, params: { body: string }, queryParams: string) =>
    RecruitApiClient.post(`${BASE_URL}/jobs/${jobId}/import_resources${queryParams}`, params);
  cloneJobsOptions = (params: {}) =>
    RecruitApiClient.get(`${BASE_URL}/jobs/jobs_for_clone`, params);
  createJob = (params: { body: string }) => RecruitApiClient.post(`${BASE_URL}/jobs/`, params);
  getEntities = (): Promise<{ res: { entities: IEntity[]; current_entity: IEntity } }> =>
    RecruitApiClient.get(`/api/v4/entities`);
}

export default new Api();
